import {Component, OnDestroy, OnInit} from '@angular/core';
import {Poplatok} from '../model/poplatok';
import {AppService} from '../app.service';
import {Subscription} from 'rxjs';

@Component({
    selector: 'app-poplatky',
    templateUrl: './poplatky.component.html',
    styleUrls: ['./poplatky.component.css'],
    standalone: false
})
export class PoplatkyComponent implements OnInit, OnDestroy {

  data: Poplatok[];
  poplatkyData: Subscription;
  show = false;
  loading = true;
  loading2 = false;

  private onPoplatkyClickSubscription: Subscription;

  constructor(private appService: AppService) { }

  ngOnInit() {
    this.poplatkyData = this.appService.poplatkyData
      .subscribe((data) => {
        this.data = data;
        this.loading = false;
      });
    this.appService.fetchPoplatky();

    this.onPoplatkyClickSubscription =
        this.appService.onPoplatkyClickSubject.subscribe(
            () => {
              this.show = !this.show;
            }
        );
  }

  ngOnDestroy(): void {
    this.poplatkyData.unsubscribe();
    this.onPoplatkyClickSubscription.unsubscribe();
  }

}
